<script setup>
import { computed } from 'vue'
import Icon from '@/components/shell/Icon.vue'
import { store } from '@/store/appStore.js'
const pharmacy  = computed(() => store.activePharmacy.value)
const campaigns = computed(() => [...store.data.myCampaigns.value].sort((a,b) => {
  if (a.orderedThisProduct !== b.orderedThisProduct) return a.orderedThisProduct ? -1 : 1
  return (b.territoryRelevanceScore||0) - (a.territoryRelevanceScore||0)
}))
const isActive = c => { const today='2026-07-28'; return c.startDate<=today && c.endDate>=today }
</script>
<template>
  <div>
    <div class="card module-header"><span class="eyebrow">My Promotions</span><h2>{{ campaigns.length }} campaigns relevant to {{ pharmacy?.pharmacyName }}</h2><p class="muted">Ranked by relevance to your territory ({{ pharmacy?.territory }})</p></div>
    <div v-if="!campaigns.length" class="card empty-state"><div class="icon-wrap"><Icon name="megaphone" :size="26" /></div><h3>No promotions to show</h3></div>
    <div v-else style="display:grid;grid-template-columns:repeat(auto-fit,minmax(280px,1fr));gap:16px;">
      <div v-for="c in campaigns" :key="c.campaignName" class="card" style="padding:18px 20px;">
        <div style="display:flex;justify-content:space-between;align-items:flex-start;gap:10px;margin-bottom:8px;">
          <h3 style="font-size:16px;">{{ c.campaignName }}</h3>
          <span class="status-pill" :class="isActive(c)?'green':'yellow'"><span class="dot"></span>{{ isActive(c)?'Active':'Ended' }}</span>
        </div>
        <div class="cell-muted" style="font-size:13px;margin-bottom:8px;">Featured: <strong style="color:var(--color-text);">{{ c.productName }}</strong></div>
        <span v-if="c.orderedThisProduct" class="tier-badge Gold" style="margin-bottom:10px;display:inline-block;">You stock this</span>
        <div class="oos-remarks" style="margin-top:8px;">{{ c.relevanceNote }}</div>
        <div class="oos-meta-grid" style="font-size:12.5px;margin-top:12px;">
          <div><div class="label">Runs</div>{{ c.startDate }} → {{ c.endDate }}</div>
          <div><div class="label">Adoption Rate</div>{{ c.adoptionRate }}%</div>
        </div>
        <div v-if="c.scenarioNote" class="oos-remarks" style="margin-top:12px;">{{ c.scenarioNote }}</div>
      </div>
    </div>
  </div>
</template>
